module.exports = __webpack_public_path__ + "img/lao-people's-democratic-republic.6e84fa67.svg";